import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { toast } from "react-toastify"
import api, { timeout } from "../../api"
import { setMessage } from "../message/messageSlice"

// WORK PLANS
export const getWorkplans = createAsyncThunk(
  "budget/getWorkplans",
  async ({ year, mda }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/wp/feature/wps?year=${year}&mda=${mda}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)

export const getWorkplanDeliverableDropdown = createAsyncThunk(
  "budget/getWorkplanDeliverableDropdown",
  async ({ wp }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/wp/deliverables/${wp}`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      return rejectWithValue(message)
    }
  }
)
export const getWorkplansDropdown = createAsyncThunk(
  "budget/getWorkplansDropdown",
  async ({ year, mda }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/wp/wps?year=${year}&mda=${mda}`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      return rejectWithValue(message)
    }
  }
)
export const getMDAworkplans = createAsyncThunk(
  "budget/getMDAworkplans",
  async ({ year }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/wp/feature/mda/wps?year=${year}`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)
export const getMDAWorkplansDropdown = createAsyncThunk(
  "budget/getMDAWorkplansDropdown",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/wp/mda/wps`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)
export const getWorkPlanDetail = createAsyncThunk(
  "budget/getWorkPlanDetail",
  async ({ id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/wp/feature/wps/${id}`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)

export const getDeliverablesDropdown = createAsyncThunk(
  "budget/getDeliverablesDropdown",
  async ({ budgetId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/wp/deliverables?budgets=${budgetId}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)
export const getDeliverableDropdown = createAsyncThunk(
  "budget/getDeliverableDropdown",
  async ({ mda, year }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/wp/deliverables/basic?year=${year}&mda=${mda}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)
export const addWorkplan = createAsyncThunk(
  "budget/addWorkplan",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v2/wp/feature/add", inputData)
      if (response) {
        toast.success("Work plan added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const addMDAWorkplan = createAsyncThunk(
  "budget/addMDAWorkplan",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v2/wp/feature/mda/add", inputData)
      if (response) {
        toast.success("Work plan added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const updateWorkplan = createAsyncThunk(
  "budget/updateWorkplan",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v2/wp/feature/edit", inputData)
      if (response) {
        toast.success("Work plan edited successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const updateWorkplanActivityProgress = createAsyncThunk(
  "budget/updateWorkplan",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/wp/deliverable/progress",
        inputData
      )
      if (response) {
        toast.success("Activity progress updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteworkplan = createAsyncThunk(
  "budget/deleteworkplan",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(`abide/v2/wp/delete/${id}`, {})
      if (response) {
        toast.success("Work plan deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//DELIVERABLE
export const getDeliverable = createAsyncThunk(
  "budget/getDeliverable",
  async ({ id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/wp/feature/activity/${id}`)
      // const response = await api.get(`abide/v2/wp/deliverable/${id}`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)
export const addDeliverable = createAsyncThunk(
  "budget/addDeliverable",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/wp/feature/activity/add",
        inputData
      )
      if (response) {
        toast.success("Activity added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const updateDeliverable = createAsyncThunk(
  "budget/updateDeliverable",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/wp/feature/activity/edit",
        inputData
      )
      if (response) {
        toast.success("Activity edited successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteDeliverable = createAsyncThunk(
  "budget/deleteDeliverable",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/wp/feature/activity/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Activity deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
//WORK  PLAN ACTIVITIES
export const getWorkplanActivities = createAsyncThunk(
  "budget/getWorkplanActivities",
  async (
    { id, year, search, priority, cursor, navigation, pagesize },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = await api.get(`abide/v2/wp/feature/activities`, {
        params: {
          wp: id,
          year,
          search,
          priority,
          cursor,
          navigation,
          "page-size": pagesize,
        },
      })
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)
export const addActivityPartner = createAsyncThunk(
  "budget/addActivityPartner",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/wp/feature/partner/add",
        inputData
      )
      if (response) {
        toast.success("Partner added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteActivityPartner = createAsyncThunk(
  "budget/deleteActivityPartner",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/wp/feature/partner/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Partner deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const addActivityLocation = createAsyncThunk(
  "budget/addActivityLocation",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v2/wp/location/add", inputData)
      if (response) {
        toast.success("Location added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteActivityLocation = createAsyncThunk(
  "budget/deleteActivityPartner",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(`abide/v2/wp/location/delete/${id}`, {})
      if (response) {
        toast.success("Location deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const addKPI = createAsyncThunk(
  "budget/adjustKPI",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v2/wp/feature/kpi/add", inputData)
      if (response) {
        toast.success("KPI added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const adjustKPI = createAsyncThunk(
  "budget/adjustKPI",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v2/wp/feature/kpi/edit", inputData)
      if (response) {
        toast.success("KPI updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteKPI = createAsyncThunk(
  "budget/deleteKPI",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/wp/feature/kpi/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("KPI deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
//CONTRACT
export const addActivityContract = createAsyncThunk(
  "budget/addActivityContract",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/wp/feature/contract/add",
        inputData
      )
      if (response) {
        toast.success("Contract added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editActivityContract = createAsyncThunk(
  "budget/editActivityContract",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/wp/feature/contract/edit",
        inputData
      )
      if (response) {
        toast.success("Contract updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteActivityContract = createAsyncThunk(
  "budget/deleteActivityContract",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/wp/feature/contract/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Contract deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
//PERFORMANCE
export const addActivityPerformance = createAsyncThunk(
  "budget/addActivityPerformance",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/wp/feature/performance/add",
        inputData
      )
      if (response) {
        toast.success("Performance added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editActivityPerformance = createAsyncThunk(
  "budget/editActivityPerformance",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/wp/feature/performance/edit",
        inputData
      )
      if (response) {
        toast.success("Performance updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteActivityPerformance = createAsyncThunk(
  "budget/deleteActivityPerformance",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/wp/feature/performance/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Performance deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editActivityMoneyRelease = createAsyncThunk(
  "budget/editActivityMoneyRelease",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/wp/feature/release/edit",
        inputData
      )
      if (response) {
        toast.success("Release updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteActivityMoneyRelease = createAsyncThunk(
  "budget/deleteActivityMoneyRelease",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/wp/feature/release/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Release deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
// BUDGETS
export const getBudgetPreparations = createAsyncThunk(
  "budget/getBudgetPreparations",
  async ({ year, purpose }, { dispatch, rejectWithValue }) => {
    try {
      // const response = await api.get(
      //   `abide/v2/budget/main/budgets?year=${year}&purpose=${purpose}`
      // )
      const response = await api.get(
        `abide/v2/budget/main/budget?year=${year}&purpose=${purpose}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)
// BUDGETS
export const getBudgetDropdown = createAsyncThunk(
  "budget/getBudgetDropdown",
  async ({ year, purpose }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/budget/main/budgets?year=${year}&purpose=${purpose}`
      )
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const getBudgetDetail = createAsyncThunk(
  "budget/getBudgetDetail",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/budget/main/overview/${id}`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const getbudgetSummary = createAsyncThunk(
  "budget/getbudgetSummary",
  async ({ id, purpose }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/main/budget/summary/${id}?purpose?=${purpose}`
      )
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)

export const getbasicbudgetinfo = createAsyncThunk(
  "budget/getbasicbudgetinfo",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/budget/budgets/basic`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)

export const initiatebudget = createAsyncThunk(
  "budget/initiatebudget",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/budget/main/budget/add",
        inputData
      )
      if (response) {
        toast.success("Budget initiated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const updatecallcircular = createAsyncThunk(
  "budget/updatecallcircular",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/budget/main/budget/circular/update`,
        inputData
      )
      if (response) {
        toast.success("Call circular update successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const updatebudget = createAsyncThunk(
  "budget/updatebudget",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/budget/main/budget/update",
        inputData
      )
      if (response) {
        toast.success("Budget edited successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deletebudget = createAsyncThunk(
  "budget/deletebudget",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/budget/main/budget/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Budget deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const getSegmentConfigurations = createAsyncThunk(
  "budget/getSegmentConfigurations",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/segment`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const getSegmentCategories = createAsyncThunk(
  "budget/getSegmentCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/segments/segments/tabs`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const getBudgetProposalCategories = createAsyncThunk(
  "budget/getBudgetProposalCategories",
  async ({ budget, type }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/proposal/proposals`, {
        params: {
          budgets: budget,
          type,
        },
      })
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const getParticipatingMDAsBudget = createAsyncThunk(
  "budget/getParticipatingMDAsBudget",
  async ({ budgetId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/budget/main/budget/participant/${budgetId}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)
export const getParticipatingMDAsDropdown = createAsyncThunk(
  "budget/getParticipatingMDAsDropdown",
  async ({ budgetId }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/budget/main/budget/participant/basic/${budgetId}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message

      return rejectWithValue(newMessage)
    }
  }
)

export const getparticipatingMDAs = createAsyncThunk(
  "budget/getparticipatingMDAs",
  async ({ budgetId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/budget/main/budget/participants/${budgetId}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)

//BUDGET CALL CIRCULAR/MDA BUDGET
export const addCallCircular = createAsyncThunk(
  "budget/addCallCircular",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/budget/main/budget/participants/add",
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const removeParticipatingMDA = createAsyncThunk(
  "budget/removeParticipatingMDA",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/budget/main/budget/participant/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("MDA removed successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const inviteParticipatingMDAs = createAsyncThunk(
  "budget/inviteParticipatingMDAs",
  async ({ budgetId }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/budget/main/budget/participants/invite/${budgetId}`,
        {}
      )
      if (response) {
        toast.success("Invitaion sent successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
//CALL CIRCULAR CEILING (THRESHOLD/TARGET)
export const getSpendingLimits = createAsyncThunk(
  "budget/getSpendingLimits",
  async ({ id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/proposal/envelopes/${id}`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)
//CALL CIRCULAR CEILING (THRESHOLD/TARGET)
export const getSpendingLimitDetail = createAsyncThunk(
  "budget/getSpendingLimitDetail",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/proposal/envelope/${id}`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)

export const addSpending = createAsyncThunk(
  "budget/addSpending",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/proposal/envelope/add`,
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
//CALL CIRCULAR CEILING (THRESHOLD/TARGET)
export const getBudgetSpendingLimits = createAsyncThunk(
  "budget/getBudgetSpendingLimits",
  async ({ budgetId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/budget/limits/${budgetId}`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)
export const editSpending = createAsyncThunk(
  "budget/editSpending",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/proposal/envelope/edit",
        inputData
      )
      if (response) {
        toast.success("Spending limit updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteSpending = createAsyncThunk(
  "budget/deleteSpending",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/proposal/envelope/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Spending limit deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
//BUDGET BULK SPENDING LIMITS
export const addSpendinglimits = createAsyncThunk(
  "budget/addSpendinglimits",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(`abide/v2/budget/limits/add`, inputData)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const adjustSpendingLimits = createAsyncThunk(
  "budget/adjustSpendingLimits",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(`abide/v2/budget/limits/edit`, inputData)
      if (response) {
        toast.success("Spending limit adjusted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//MDA BUDGET ITEM

export const getGroupedBudgetItem = createAsyncThunk(
  "government/getGroupedBudgetItem",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/business/mda/items`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const getGroupedMDABudgetitem = createAsyncThunk(
  "government/getGroupedMDABudgetitem",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/business/mda/grouped/items`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)

export const uploadbudgetitem = createAsyncThunk(
  "budget/uploadbudgetitem",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v1/business/item/upload",
        inputData
      )
      if (response) {
        toast.success("Budget item added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const importbudgetitems = createAsyncThunk(
  "budget/importbudgetitems",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v1/business/item/transfer",
        inputData
      )
      if (response) {
        toast.success("Budget item imported successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const uploadmdabudgetitem = createAsyncThunk(
  "budget/uploadmdabudgetitem",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v1/business/item/upload",
        inputData
      )
      if (response) {
        toast.success("Budget item added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const editbudgetitem = createAsyncThunk(
  "budget/editbudgetitem",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v1/business/item/edit", inputData)
      if (response) {
        toast.success("Budget item edited successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deletebudgetitem = createAsyncThunk(
  "budget/deletebudgetitem",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(`abide/v1/business/item/delete/${id}`, {})
      if (response) {
        toast.success("Budget item deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
// BUDGETS
export const getMyMDABudgets = createAsyncThunk(
  "budget/getMyMDABudgets",
  async ({ purpose }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/budget/mda/budget?purpose=${purpose}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)
// BUDGETS DROPDOWN
export const getMyMDABudgetsDropdown = createAsyncThunk(
  "budget/getMyMDABudgetsDropdown",
  async ({ purpose }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/budget/mda/budget/basic`, {
        params: { purpose },
      })
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)
export const getMyMDABudgetDetail = createAsyncThunk(
  "budget/getMyMDABudgetDetail",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/budget/mda/budgets/overview/${id}`
      )
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const getMDAbudgetProposalDetail = createAsyncThunk(
  "budget/getMDAbudgetProposalDetail",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/mda/budget/proposal/${id}`
      )
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const submitBudget = createAsyncThunk(
  "budget/submitBudget",
  async ({ budgetId }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/budget/mda/budget/submit/${budgetId}`,
        {}
      )
      if (response) {
        toast.success("Budget submitted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const getMDABudgetDetail = createAsyncThunk(
  "budget/getMDABudgetDetail",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/budget/mda/budgets/budget/${id}`)
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)

export const uploadmdacallcircular = createAsyncThunk(
  "budget/uploadmdacallcircular",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v1/budget/mda/budget/update",
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const submitmdacallcircular = createAsyncThunk(
  "budget/submitmdacallcircular",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v1/budget/mda/budget/submit/${id}`,
        {}
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deletemdacallcircular = createAsyncThunk(
  "budget/deletemdacallcircular",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v1/budget/mda/budget/delete/${id}`,
        {}
      )
      if (response) {
        toast.success("Call circular deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const approvebudgetentries = createAsyncThunk(
  "budget/approvebudgetentries",
  async ({ inputData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(
        "abide/v1/budget/mda/budget/approve/entries",
        inputData
      )
      if (response) {
        toast.success("Budget entry approved successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)

export const getBudgetAntecedence = createAsyncThunk(
  "budget/getBudgetAntecedence",
  async ({ year, item, project, mda }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/antecedence?year=${year}&item=${item}&project=${project}&mda=${mda}`
      )
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const getspendinglimitbalance = createAsyncThunk(
  "budget/getspendinglimitbalance",
  async ({ budgetId, head }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/envelope/${budgetId}/${head}`
      )
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)

export const getMDABudgetProposals = createAsyncThunk(
  "budget/getMDABudgetProposals",
  async ({ category, budget }, { rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/proposal/mda/budget/proposal`, {
        params: { subhead: category, budgets: budget },
      })
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const getbasicproposals = createAsyncThunk(
  "budget/getbasicproposals",
  async ({ budgetId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v2/proposal/basic/${budgetId}`)
      return response?.data
    } catch (error) {
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)
export const getCategorizedProposals = createAsyncThunk(
  "budget/getCategorizedProposals",
  async ({ budget, type }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/proposal/mda/budget/categorized/proposals`,
        { params: { budget, type } }
      )
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)

//ADD MDA PROPOSALS
export const addMDAProposal = createAsyncThunk(
  "budget/addMDAProposal",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/proposal/mda/budget/proposal/add",
        inputData
      )
      if (response) {
        toast.success("Proposal added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//EDIT MDA PROPOSALS
export const editMDAProposal = createAsyncThunk(
  "budget/editMDARecurrentProposal",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(
        "abide/v2/proposal/mda/budget/proposal/edit",
        inputData
      )
      if (response) {
        toast.success("Proposal updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//DELETE PROPOSALS
export const deleteMDAProposal = createAsyncThunk(
  "budget/deleteMDAProposal",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(`abide/v2/proposal/delete/${id}`)
      if (response) {
        toast.success("Proposal deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

//GROUPED MDA BUDGETS
export const getGroupedMDABudget = createAsyncThunk(
  "budget/getGroupedMDABudget",
  async ({ purpose }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(
        `abide/v2/budget/mda/budgets/grouped?purpose=${purpose}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)
//START IMPLEMENTATION
export const startImplementation = createAsyncThunk(
  "budget/startImplementation",
  async ({ budgetId }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v2/budget/main/budget/implement/${budgetId}`,
        {}
      )
      if (response) {
        toast.success("Implementaion started successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

// HARMONIZATION
export const recommendationMDABudget = createAsyncThunk(
  "budget/recommendationMDABudget",
  async ({ inputData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(
        `abide/v2/proposal/mda/budget/proposal/harmonise`,
        inputData
      )
      if (response) {
        toast.success("Budget harmonized successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)
export const mdabudgetbreakdownrecommendation = createAsyncThunk(
  "budget/mdabudgetbreakdownrecommendation",
  async ({ inputData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(
        `abide/v2/proposal/mda/budget/proposal/propose/recommend`,
        inputData
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage = error?.response?.data?.message
        ? error?.response?.data?.message
        : error?.response?.data?.error
        ? error?.response?.data?.error
        : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(newMessage))
      return rejectWithValue()
    }
  }
)

const initialState = {
  loading: false,
  budgetitems: null,
  mdaitems: null,
  budgets: null,
  itemloading: false,
  items: null,
  antecedence: null,
  balance: null,
  spendinglimit: null,
  configloading: false,
  segmentconfig: null,
  segmenttabs: null,
  budgetdetail: null,
  budgetsummary: null,
  summaryloading: false,
  participatingMDAs: null,
  mdaLoading: false,
  participatingMDAdetail: null,
  spendinglimits: null,
  ceilingloading: false,
  mdabudgets: null,
  mdabudgetdetail: null,
  mdabudgetentries: null,
  mdabudgetentry: null,
  breakdowns: null,
  entryloading: false,
  allbudgetitems: null,
  budgetbasic: null,
  votebookentries: null,
  votebookentry: null,
  attachment: null,
  data: null,
  detail: null,
  deliverable: null,
  activities: null,
  deliverableDropdown: null,
  isloading: false,
  workplans: null,
  workIsLoading: false,
  deliverables: null,
  revenueentries: null,
  groupedbudgetitems: null,
  groupedmdabudgetitems: null,
  categories: null,
  proposals: null,
  proposalCategories: null,
  participatingMDAsDropdown: null,
  mdaBudgetsBasic: null,
  deliverablesDropdown: null,
}

const budgetSlice = createSlice({
  name: "budget",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // WORK PLANS
    builder.addCase(getWorkplans.pending, (state) => {
      state.workIsLoading = true
      state.workplans = null
    })
    builder.addCase(getWorkplans.fulfilled, (state, { payload }) => {
      state.workIsLoading = false
      state.workplans = payload.data
    })
    builder.addCase(getWorkplans.rejected, (state) => {
      state.workIsLoading = false
      state.workplans = null
    })
    builder.addCase(getWorkplansDropdown.fulfilled, (state, { payload }) => {
      state.workplans = payload.data
    })
    builder.addCase(
      getWorkplanDeliverableDropdown.fulfilled,
      (state, { payload }) => {
        state.deliverables = payload.data
      }
    )

    // MDA WORK PLANS
    builder.addCase(getMDAworkplans.pending, (state) => {
      state.workIsLoading = true
      state.workplans = null
    })
    builder.addCase(getMDAworkplans.fulfilled, (state, { payload }) => {
      state.workIsLoading = false
      state.workplans = payload.data
    })
    builder.addCase(getMDAworkplans.rejected, (state) => {
      state.workIsLoading = false
      state.workplans = null
    })
    builder.addCase(getMDAWorkplansDropdown.fulfilled, (state, { payload }) => {
      state.workplans = payload.data
    })

    // WORK PLAN DETAIL
    builder.addCase(getWorkPlanDetail.pending, (state) => {
      state.loading = true
      state.detail = null
    })
    builder.addCase(getWorkPlanDetail.fulfilled, (state, { payload }) => {
      state.loading = false
      state.detail = payload.data
    })

    builder.addCase(getWorkPlanDetail.rejected, (state) => {
      state.loading = false
      state.detail = null
    })
    //DELIVERABLE
    builder.addCase(getDeliverable.pending, (state) => {
      state.isloading = true
      state.deliverable = null
    })
    builder.addCase(getDeliverable.fulfilled, (state, { payload }) => {
      state.isloading = false
      state.deliverable = payload.data
    })
    builder.addCase(getDeliverable.rejected, (state) => {
      state.isloading = false
      state.deliverable = null
    })
    //WORK PLAN ACTIVITIES
    builder.addCase(getWorkplanActivities.pending, (state) => {
      state.loading = true
      state.activities = null
    })
    builder.addCase(getWorkplanActivities.fulfilled, (state, { payload }) => {
      state.loading = false
      state.activities = payload.data
    })
    builder.addCase(getWorkplanActivities.rejected, (state) => {
      state.loading = false
      state.activities = null
    })

    builder.addCase(getDeliverableDropdown.fulfilled, (state, { payload }) => {
      state.deliverableDropdown = payload.data
    })
    builder.addCase(getDeliverablesDropdown.fulfilled, (state, { payload }) => {
      state.deliverablesDropdown = payload.data
    })
    builder.addCase(getBudgetPreparations.pending, (state) => {
      state.loading = true
      state.budgets = null
    })
    builder.addCase(getBudgetPreparations.fulfilled, (state, { payload }) => {
      state.loading = false
      state.budgets = payload.data
    })
    builder.addCase(getBudgetPreparations.rejected, (state) => {
      state.loading = false
      state.budgets = null
    })
    //MAIN BUDGET FOR DROPDOWN
    builder.addCase(getBudgetDropdown.pending, (state) => {
      state.loading = true
      state.budgets = null
    })
    builder.addCase(getBudgetDropdown.fulfilled, (state, { payload }) => {
      state.loading = false
      state.budgets = payload.data
    })
    builder.addCase(getBudgetDropdown.rejected, (state) => {
      state.loading = false
      state.budgets = null
    })
    //Grouped budget items
    builder.addCase(getGroupedBudgetItem.fulfilled, (state, { payload }) => {
      state.groupedbudgetitems = payload.data
    })
    builder.addCase(getGroupedMDABudgetitem.fulfilled, (state, { payload }) => {
      state.groupedmdabudgetitems = payload.data
    })

    //basic budget info
    builder.addCase(getbasicbudgetinfo.fulfilled, (state, { payload }) => {
      state.loading = false
      state.budgetbasic = payload.data
    })

    //budget detail
    builder.addCase(getBudgetDetail.pending, (state) => {
      state.loading = true
      state.budgetdetail = null
    })
    builder.addCase(getBudgetDetail.fulfilled, (state, { payload }) => {
      state.loading = false
      state.budgetdetail = payload.data
    })
    builder.addCase(getBudgetDetail.rejected, (state) => {
      state.loading = false
      state.budgetdetail = null
    })
    //budget detail summary
    builder.addCase(getbudgetSummary.pending, (state) => {
      state.summaryloading = true
      state.budgetsummary = null
    })
    builder.addCase(getbudgetSummary.fulfilled, (state, { payload }) => {
      state.summaryloading = false
      state.budgetsummary = payload.data
    })
    builder.addCase(getbudgetSummary.rejected, (state) => {
      state.summaryloading = false
      state.budgetsummary = null
    })

    //Segment Configuration
    builder.addCase(getSegmentConfigurations.pending, (state) => {
      state.configloading = true
      state.segmentconfig = null
    })
    builder.addCase(
      getSegmentConfigurations.fulfilled,
      (state, { payload }) => {
        state.configloading = false
        state.segmentconfig = payload.data
      }
    )
    builder.addCase(getSegmentConfigurations.rejected, (state) => {
      state.configloading = false
      state.segmentconfig = null
    })

    //budget entry tabs
    builder.addCase(getSegmentCategories.pending, (state) => {
      state.configloading = true
      state.segmenttabs = null
    })
    builder.addCase(getSegmentCategories.fulfilled, (state, { payload }) => {
      state.configloading = false
      state.segmenttabs = payload.data
    })
    builder.addCase(getSegmentCategories.rejected, (state) => {
      state.configloading = false
      state.segmenttabs = null
    })

    //budget proposals tabs
    builder.addCase(
      getBudgetProposalCategories.fulfilled,
      (state, { payload }) => {
        state.proposalCategories = payload.data
      }
    )

    //PARTICIPATING MDAs
    builder.addCase(getParticipatingMDAsBudget.pending, (state) => {
      state.mdaLoading = true
      state.participatingMDAs = null
    })
    builder.addCase(
      getParticipatingMDAsBudget.fulfilled,
      (state, { payload }) => {
        state.mdaLoading = false
        state.participatingMDAs = payload.data
      }
    )
    builder.addCase(getParticipatingMDAsBudget.rejected, (state) => {
      state.mdaLoading = false
      state.participatingMDAs = null
    })
    builder.addCase(
      getParticipatingMDAsDropdown.fulfilled,
      (state, { payload }) => {
        state.participatingMDAsDropdown = payload.data
      }
    )
    builder.addCase(getparticipatingMDAs.fulfilled, (state, { payload }) => {
      state.participatingMDAs = payload.data
    })

    builder.addCase(getSpendingLimits.pending, (state) => {
      state.loading = true
      state.spendinglimits = null
    })
    builder.addCase(getSpendingLimits.fulfilled, (state, { payload }) => {
      state.loading = false
      state.spendinglimits = payload.data
    })
    builder.addCase(getSpendingLimits.rejected, (state) => {
      state.loading = false
      state.spendinglimits = null
    })

    builder.addCase(getSpendingLimitDetail.fulfilled, (state, { payload }) => {
      state.spendinglimit = payload.data
    })
    //BULK SPENDING LIMITS
    builder.addCase(getBudgetSpendingLimits.pending, (state) => {
      state.loading = true
      state.spendinglimits = null
    })
    builder.addCase(getBudgetSpendingLimits.fulfilled, (state, { payload }) => {
      state.loading = false
      state.spendinglimits = payload.data
    })
    builder.addCase(getBudgetSpendingLimits.rejected, (state) => {
      state.loading = false
      state.spendinglimits = null
    })

    //MY MDA BUDGETS
    builder.addCase(getMyMDABudgets.pending, (state) => {
      state.loading = true
      state.mdabudgets = null
    })
    builder.addCase(getMyMDABudgets.fulfilled, (state, { payload }) => {
      state.loading = false
      state.mdabudgets = payload.data
    })
    builder.addCase(getMyMDABudgets.rejected, (state) => {
      state.loading = false
      state.mdabudgets = null
    })
    //Work MDA BUDGETS DROPDOWN

    builder.addCase(getMyMDABudgetsDropdown.pending, (state) => {
      state.loading = true
      state.mdaBudgetsBasic = null
    })
    builder.addCase(getMyMDABudgetsDropdown.fulfilled, (state, { payload }) => {
      state.loading = false
      state.mdaBudgetsBasic = payload.data
    })
    builder.addCase(getMyMDABudgetsDropdown.rejected, (state) => {
      state.loading = false
      state.mdaBudgetsBasic = null
    })
    //MDA budget details
    builder.addCase(getMyMDABudgetDetail.pending, (state) => {
      state.loading = true
      state.budgetdetail = null
    })
    builder.addCase(getMyMDABudgetDetail.fulfilled, (state, { payload }) => {
      state.loading = false
      state.budgetdetail = payload.data
    })
    builder.addCase(getMyMDABudgetDetail.rejected, (state) => {
      state.loading = false
      state.budgetdetail = null
    })

    builder.addCase(getMDABudgetDetail.pending, (state) => {
      state.loading = true
      state.mdabudgetdetail = null
    })
    builder.addCase(getMDABudgetDetail.fulfilled, (state, { payload }) => {
      state.loading = false
      state.mdabudgetdetail = payload.data
    })
    builder.addCase(getMDABudgetDetail.rejected, (state) => {
      state.loading = false
      state.mdabudgetdetail = null
    })

    builder.addCase(getBudgetAntecedence.fulfilled, (state, { payload }) => {
      state.antecedence = payload.data
    })
    builder.addCase(getspendinglimitbalance.fulfilled, (state, { payload }) => {
      state.balance = payload.data
    })
    //Grouped MDA budgets
    builder.addCase(getGroupedMDABudget.pending, (state) => {
      state.loading = true
      state.mdabudgets = null
    })
    builder.addCase(getGroupedMDABudget.fulfilled, (state, { payload }) => {
      state.loading = false
      state.mdabudgets = payload.data
    })
    builder.addCase(getGroupedMDABudget.rejected, (state) => {
      state.loading = false
      state.mdabudgets = null
    })

    //categorized budget proposals
    builder.addCase(getCategorizedProposals.fulfilled, (state, { payload }) => {
      state.categories = payload.data
    })

    builder.addCase(getbasicproposals.fulfilled, (state, { payload }) => {
      state.proposals = payload.data
    })

    //mda budget proposals
    builder.addCase(getMDABudgetProposals.pending, (state) => {
      state.entryloading = true
      state.mdabudgetentries = null
    })
    builder.addCase(getMDABudgetProposals.fulfilled, (state, { payload }) => {
      state.entryloading = false
      state.mdabudgetentries = payload.data
    })
    builder.addCase(getMDABudgetProposals.rejected, (state) => {
      state.entryloading = false
      state.mdabudgetentries = null
    })
    builder.addCase(
      getMDAbudgetProposalDetail.fulfilled,
      (state, { payload }) => {
        state.mdabudgetentry = payload.data
      }
    )
  },
})

export default budgetSlice.reducer
